import { render, staticRenderFns } from "./Provinsi.vue?vue&type=template&id=22f04425"
import script from "./Provinsi.vue?vue&type=script&lang=js"
export * from "./Provinsi.vue?vue&type=script&lang=js"
import style0 from "./Provinsi.vue?vue&type=style&index=0&id=22f04425&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports